import ResponsiveImage from "../../../../../components/Responsive/Image";

export default function ScheduleImage({ image }) {
  return (
    <div>
      <ResponsiveImage {...image} />
    </div>
  );
}
